var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-editor',_vm._b({ref:"editor",attrs:{"editorOptions":_vm.editorOptions,"value":_vm.value},on:{"input":function (value) { return _vm.$emit('input', value); }}},'vue-editor',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }